import { DIAS, normalizarHorario } from "@/components/HorarioEditor";

export default function HorarioResumen({ horario, compact = false }) {
  if (!horario) {
    return <p className="text-sm text-zinc-400">Sin horario definido</p>;
  }
  const n = normalizarHorario(horario);
  const activos = DIAS.filter(([k]) => n[k]?.activo);

  if (!activos.length) {
    return <p className="text-sm text-zinc-400">Sin días laborables</p>;
  }

  if (compact) {
    const ref = n[activos[0][0]];
    const tramos = ref.turnos.map((t) => `${t.inicio}–${t.fin}`).join(" · ");
    return (
      <p className="text-sm text-zinc-700">
        {activos.length === 7 ? "Todos los días" : `${activos.length} días/sem`} · {tramos}
      </p>
    );
  }

  return (
    <div className="divide-y divide-zinc-100 rounded-xl border border-zinc-200 bg-white">
      {DIAS.map(([key, label]) => {
        const d = n[key];
        const tramos = d.turnos.map((t) => `${t.inicio}–${t.fin}`).join(" · ");
        return (
          <div key={key} className={`flex items-center justify-between px-3 py-2 text-sm ${d.activo ? "" : "opacity-50"}`}>
            <span className="font-medium text-zinc-700">{label}</span>
            <span className={d.activo ? "text-indigo-700" : "text-zinc-400"}>
              {d.activo ? tramos : "Descanso"}
            </span>
          </div>
        );
      })}
    </div>
  );
}
